import { Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { AboutUsSection } from '../../../components/about/about-us-section/about-us-section';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-about-us-page',
  imports: [
    MatDividerModule,
    AboutUsSection,
  ],
  templateUrl: './about-us-page.html',
  styleUrl: './about-us-page.scss',
})
export class AboutUsPage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('About Us');
  }
}
